import "./career.scss";
import * as React from 'react';
import PortfolioList from "../portfolioList/PortfolioList";
import {useState} from "react";
import {faBriefcase, faSchool} from "@fortawesome/free-solid-svg-icons";
import {TimeLine} from "../TimeLine/TimeLine";

export default function Career(){
    const [selected, setSelected] = useState("experience");
    const list = [
        {
            id: "education",
            title: "Education",
            icon: faSchool
        },
        {
            id: "experience",
            title: "Experience",
            icon: faBriefcase
        },
    ]

    return (
        <div className="career" id={"career"}>
            <ul className={"career-btn"}>
                {list.map(item=>(
                <PortfolioList title={item.title} active={selected === item.id} icon={item.icon} setSelected={setSelected} id={item.id}/>
            ))}
            </ul>
            <TimeLine isEducationSelected={selected === "education"} />
        </div>
    );
}